





















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { SurveyModel, ProgressButtons, ProgressButtonsResponsivityManager, IProgressButtonsViewModel } from "survey-core";

@Component
export class ProgressButtonsComponent extends Vue implements IProgressButtonsViewModel {
  private respManager: ProgressButtonsResponsivityManager;
  @Prop() survey: SurveyModel;
  @Prop() model: ProgressButtons;
  @Prop() container: string;
  public hasScroller: boolean = false;
  public canShowHeader: boolean = false;
  public canShowFooter: boolean = false;
  public canShowItemTitles: boolean = true;
  constructor() {
    super();
  }
  onResize(canShowItemTitles: boolean): void {
    this.canShowItemTitles = canShowItemTitles;
    this.canShowHeader = !this.canShowItemTitles;
  }
  onUpdateScroller(hasScroller: boolean): void {
    this.hasScroller = hasScroller;
  }
  onUpdateSettings(): void {
    this.canShowItemTitles = this.model.showItemTitles;
    this.canShowFooter = !this.model.showItemTitles;
  }

  public get css() {
    return this.survey.css;
  }
  mounted() {
    const element: any = this.$refs["progressButtonsListContainer"];
    this.respManager = new ProgressButtonsResponsivityManager(this.model, element, this);
  }
  public clickScrollButton(isLeftScroll: boolean): void {
    let listContainerElement: any = this.$refs["progressButtonsListContainer"];
    listContainerElement.scrollLeft += (isLeftScroll ? -1 : 1) * 70;
  }
  beforeDestroy() {
    this.respManager.dispose();
  }
}

Vue.component("sv-progress-buttons", ProgressButtonsComponent);
export default ProgressButtonsComponent;
